import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { validateRuleScheduleRange } from "../../utils/ruleSchedule";

const fieldSx = { "& .MuiOutlinedInput-root": { borderRadius: 2 } };

/**
 * Début / fin d'exécution optionnels (datetime-local → ISO UTC côté API).
 */
export default function RuleScheduleFields({ validFrom, validUntil, onChange, disabled = false }) {
    const rangeError = validateRuleScheduleRange(validFrom, validUntil);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography fontSize={13} fontWeight={700} color="#334155">
                    Période d'exécution
                </Typography>
                <Typography fontSize={11} color="text.secondary">
                    Optionnel. Vide = règle permanente. Les dates sont envoyées en UTC (ISO 8601).
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    size="small"
                    type="datetime-local"
                    label="Début d'exécution"
                    value={validFrom || ""}
                    onChange={(e) => onChange({ valid_from: e.target.value })}
                    disabled={disabled}
                    error={Boolean(rangeError)}
                    InputLabelProps={{ shrink: true }}
                    helperText="valid_from"
                    sx={fieldSx}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    size="small"
                    type="datetime-local"
                    label="Fin d'exécution"
                    value={validUntil || ""}
                    onChange={(e) => onChange({ valid_until: e.target.value })}
                    disabled={disabled}
                    error={Boolean(rangeError)}
                    helperText={rangeError || "valid_until"}
                    InputLabelProps={{ shrink: true }}
                    sx={fieldSx}
                />
            </Grid>
        </Grid>
    );
}
